export const parseBundleToModel = (bundle) => ({
    ...bundle,
  });
  
  export const parseBundleToObject = (data) => ({
    ...data,
  });
